module.exports = __webpack_public_path__ + "img/cancelIcon.2c5d2381.png";